module.exports = __webpack_public_path__ + "static/box_red-7aca0fcfd2166d19c897872cf9e09afa.jpg";